module.exports = __webpack_public_path__ + "static/media/placeholder.7ae4558f.png";